export default __webpack_public_path__ + "static/media/DiscoverConnect.84637cf3.png";